<ng-container *transloco="let t">
<div class="w-100">
  <h5 class="my-2 d-flex justify-content-center">
    <span style="max-width: 500px" class="text-gray-700 fs-4 fw-bold">
      {{ t('portal.prequal.purchasePriceQuestion') }}
    </span>
  </h5>
  <div class="my-2 d-flex justify-content-center">
    <div style="max-width: 500px">
      <form #purchasePriceForm="ngForm" novalidate class="form-horizontal">
        <div class="row p-4 mb-3">
          <div class="form-group mb-3 col-md-12">
            <currency-input
              #purchasePriceInput="ngModel"
              [(ngModel)]="request.purchasePrice"
              name="purchasePriceNumber"
              [allowDecimals]="false"
              [min]="minLoanAmountValue"
              [max]="maxLoanAmountValue"
              [placeholder]="t('portal.prequal.stepPurchasePrice')"
            ></currency-input>

            <input
              type="range"
              class="form-control-range w-100"
              [(ngModel)]="request.purchasePrice"
              name="purchasePriceRange"
              [min]="minLoanAmountValue"
              [max]="maxLoanAmountValue"
              step="5000"
              required
              #purchasePriceRangeInput="ngModel"
              [ngClass]="{
                'is-invalid':
                  purchasePriceRangeInput &&
                  purchasePriceRangeInput.touched &&
                  purchasePriceRangeInput.invalid
              }"
            />
          </div>
          <small class="text-center text-muted"
            >{{ t('portal.prequal.purchasePriceSliderHint') }}</small
          >
        </div>
      </form>
    </div>
  </div>

  <div class="d-flex justify-content-between my-2">
    <span>
      <a
        href="javascript:void(0)"
        class="btn btn-light"
        (click)="closeClicked()"
      >
        {{ t('common.close') }}
      </a>
    </span>
    <span>
      <a
        href="javascript:void(0)"
        class="btn bp-primary-bg-color me-2"
        (click)="backClicked()"
      >
        {{ t('common.back') }}
      </a>
      <a
        href="javascript:void(0)"
        class="btn bp-primary-bg-color"
        (click)="nextClicked()"
      >
        {{ t('common.next') }}
      </a>
    </span>
  </div>
</div>
</ng-container>
